import { render } from "./SearchBarHeader.vue?vue&type=template&id=0162d060&scoped=true"
import script from "./SearchBarHeader.vue?vue&type=script&lang=js"
export * from "./SearchBarHeader.vue?vue&type=script&lang=js"

import "./SearchBarHeader.vue?vue&type=style&index=0&id=0162d060&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0162d060"]])

export default __exports__